import {
  Pencil,
  Trash2,
  Star,
  FileText,
  FileBarChart
} from "lucide-react";
import { BiSolidCircle } from "react-icons/bi";
import React, { useEffect, useRef, useState } from "react";
import { SetFavAction,AddTagsAction } from '../../redux/actions/report-action';
import { customReportDeleteAction } from '../../redux/actions/custom-report-action';
import { useDispatch } from "react-redux";
import errorToast from '../../components/helper-components/error-toast';
import successToast from '../../components/helper-components/success-toast';
import LoadingButtonSpinner from "../../components/helper-components/loading-button-spinner";
export default function ReportTable({ combos,cards,navigate,addedFav,setAddedFav,setCards,canEditCustomReports = false, onRefreshCustomReports }) {
    const [isModalVisible, setModalVisible] = useState(false);
    const [tagVisible, setTagVisible] = useState(false);
    const [deleteModalVisible, setDeleteModalVisible] = useState(false);
    const [reportToDelete, setReportToDelete] = useState(null);
    const [actionType, setActionType] = useState("");
    const dispatch = useDispatch();
    const [name,setName]=useState("");
    const [type,setType]=useState("");
    const [selectedCombo, setSelectedCombo] = useState(null);
    const [tagName,setTagName]=useState(null);
  const handleItemClick = (path) => {
  navigate(path); // navigate directly to the path

  // Optional scroll unlock
  const element = document.querySelector(".innerLayoutScroller");
  if (element?.style.overflow === "hidden") {
    element.style.overflow = "auto";
  }
};
const handleConfirm = () => {
  console.log(name);
    if (actionType === "remove") {
        console.log(addedFav);
        setAddedFav((prevFav) => prevFav.filter(item => item !== (name)));
        console.log(addedFav);
        console.log()
        handleAddToFav(addedFav.filter(item => item !== (name)));
    } else if (actionType === "add") {
        setAddedFav((prevFav) => [...prevFav, name]);
        console.log([...addedFav, name]);
        handleAddToFav([...addedFav, name]);
    }
    setModalVisible(false);
  };

const handleOutsideClick = (e) => {
    if (e.target.classList.contains('modal-background')) {
      setModalVisible(false);
    }
  };
  const handleTagOutsideClick = (e) => {
    if (e.target.classList.contains('tag-background')) {
      setTagVisible(false);
      setSelectedCombo(null);
    }
  };
const handleStarClick = (e,starred,type,name) => {
    e.preventDefault();
    e.stopPropagation();
    setName(name);
    setType(type);
    setActionType(starred ? "remove" : "add"); // Set the action based on the current state of the item
    setModalVisible(true); // Show the modal
  };
const handleCancel = () => {
    setModalVisible(false); // Close the modal if canceled
  };
  const handleCancelTag = () => {
    setTagVisible(false); // Close the modal if canceled
    setSelectedCombo(null);
  };
  const handleAddToFav=(data)=>{
      dispatch(SetFavAction ({data:data},onSuccess, onError));
    }
    const onSuccess = (data) => {
    console.log("Right");
    successToast("Added to favorites");
  };
  const onError =(data)=>{
    console.log("Wrong");
    errorToast();
  }
  const handleTagConfirm=()=>{
    const report = cards.find(report => report.title === name);
  
  if (report) {
    report.tag.push(tagName);
    report.tagColor.push(selectedCombo);
    const data={
            name:name,
            tags:report.tag,
            color:report.tagColor
        }
    dispatch(AddTagsAction ({data:data},onSuccess_1, onError));
    setTagVisible(false);
    setSelectedCombo(null);
  } else {
    console.warn(`Report with title "${name}" not found.`);
  }
  }
  const onSuccess_1 = (data) => {
    successToast("Tag Updated Successfully");
  };
  const handleRemoveTag=(index,tag)=>{
      const report = cards.find(report => report.title === name);
      if(report){
          report.tag.splice(index, 1);
          report.tagColor.splice(index, 1);
          setCards([...cards]);
          const data={
              name:name,
              tags:report.tag,
              color:report.tagColor
          }
          dispatch(AddTagsAction ({data:data},onSuccess_1, onError));
          setTagVisible(false);
          setSelectedCombo(null);
      }else {
          console.warn(`Report with title "${name}" not found.`);
      }
    }

  // Custom Report Delete Handlers
  const handleDeleteClick = (e, card) => {
    e.stopPropagation();
    if (card.report_id) {
      setReportToDelete(card);
      setDeleteModalVisible(true);
    }
  };

  const handleConfirmDelete = () => {
    if (!reportToDelete?.report_id) return;
    dispatch(
      customReportDeleteAction(
        { report_id: reportToDelete.report_id },
        () => {
          successToast("Report deleted successfully");
          setDeleteModalVisible(false);
          setReportToDelete(null);
          // Remove from cards
          setCards(cards.filter(c => c.report_id !== reportToDelete.report_id));
          if (onRefreshCustomReports) onRefreshCustomReports();
        },
        (error) => {
          errorToast("Failed to delete report");
          setDeleteModalVisible(false);
          setReportToDelete(null);
        }
      )
    );
  };

  const handleCancelDelete = () => {
    setDeleteModalVisible(false);
    setReportToDelete(null);
  };

  const bgClassMap = {
    "reports-shade1_bg": "bg-reports-shade1_bg",
    "reports-shade2_bg": "bg-reports-shade2_bg",
    "reports-shade3_bg": "bg-reports-shade3_bg",
    "reports-shade4_bg": "bg-reports-shade4_bg",
    "reports-shade5_bg": "bg-reports-shade5_bg",
    "reports-shade6_bg": "bg-reports-shade6_bg",
    };

    const textClassMap = {
    "reports-shade1_text": "text-reports-shade1_text",
    "reports-shade2_text": "text-reports-shade2_text",
    "reports-shade3_text": "text-reports-shade3_text",
    "reports-shade4_text": "text-reports-shade4_text",
    "reports-shade5_text": "text-reports-shade5_text",
    "reports-shade6_text": "text-reports-shade6_text",
    };

    const types_map={
      "System":4,
      "User":3
    }
  return cards.length > 0 ? (
<div className="overflow-x-auto">
      <div className="min-w-full divide-y divide-gray-200">
        <div className="grid grid-cols-6 bg-dashboard-bg-table-head dark:bg-zinc-800 text-sm font-medium text-gray-700 dark:text-gray-300 rounded-t-xl px-1 py-3">
          <div className="col-span-2">Report</div>
          <div>Module</div>
          <div>Type</div>
          <div>Tag</div>
          <div className="text-right">Actions</div>
        </div>

        {/* Table Rows */}
        {/* {cards.filter(report => 
          report && 
          report.combo !== undefined && 
          combos && combos[report.combo] && 
          report.type !== undefined && 
          types_map && types_map[report.type] !== undefined &&
          combos[types_map[report.type]] */}
        {cards.map((report, idx) => {
          // Safe access to combo data
          const reportCombo = combos[report.combo] || ['', ''];
          const typeCombo = combos[types_map[report.type]] || ['', ''];
          const primary = report.combo;
          return (
            <div
              key={idx}
              className="grid grid-cols-6 items-center bg-white dark:bg-zinc-900 px-4 py-2 border-b border-787878 cursor-pointer transform transition-transform duration-200 hover:scale-[1.01] hover:shadow-md rounded-md"
              onClick={() => handleItemClick(report.path)}
            >
              {/* Report Info */}
              <div className="col-span-2 flex gap-3 items-start">
                <div className={`p-2 ${bgClassMap[reportCombo[1]] || ''} rounded-md`}>
                  <FileBarChart
                      className={textClassMap[reportCombo[0]] || ''}
                      size={20}
                  />
                </div>
                <div>
                  <div className="text-sml font-semibold mb-1">
                    {report.title || 'Untitled'}
                  </div>
                  <div className="text-xs text-787878">{report.description || ''}</div>
                  <div className="text-[11px] text-gray-400 mt-1">
                    Updated {report.updated || 'Unknown'}
                  </div>
                </div>
              </div>

              {/* Module */}
              <div>
                <span
                  className={`text-xs font-medium px-2.5 py-0.5 rounded-full ${bgClassMap[reportCombo[1]] || ''} ${textClassMap[reportCombo[0]] || ''}`}
                >
                  {report.module}
                </span>
              </div>

              {/* Type */}
              <div>
                <span
                  className={`text-xs font-medium px-2.5 py-0.5 rounded-full ${bgClassMap[reportCombo[1]] || ''} ${textClassMap[reportCombo[0]] || ''}`}
                >
                  {report.type}
                </span>
              </div>

              {/* Tag */}
              <div className="flex flex-wrap gap-1">
                {/* <span
                        className={`text-xs font-medium px-2.5 py-0.5 rounded ${bgClassMap[combos[primary][1]]} ${textClassMap[combos[primary][0]]}`}
                    >
                        {report.module}
                </span> */}
                {report.tag.map((tagName, index) => {
                  const comboIndex = report.tagColor[index];
                  return (
                        <span
                    key={index}
                    className={`text-xs font-medium px-2.5 py-0.5 rounded relative group cursor-pointer inline-flex items-center gap-1
                        ${bgClassMap[combos[comboIndex][1]]} 
                        ${textClassMap[combos[comboIndex][0]]}`}
                    >
                    <span>{tagName}</span>
                    <button
                        className={`absolute top-0 right-0 transform translate-x-1/2 -translate-y-1/2 opacity-0 group-hover:opacity-100 transition-opacity duration-200 hover:bg-[#ff0000] hover:bg-opacity-20 hover:text-white rounded-full w-4 h-4 flex items-center justify-center text-xs leading-none ${bgClassMap[combos[comboIndex][1]]} 
                        ${textClassMap[combos[comboIndex][0]]}`}
                        onClick={(e) => {
                        e.stopPropagation();
                        setName(report.title);
                        handleRemoveTag(index, tagName);
                        }}
                    >
                        ×
                    </button>
                    </span>

                    );
                })}
                {report.tag.length < 4 && (
                    <span
                        className="text-xs font-medium px-1.5 py-0.5 rounded border border-report-side-bar-hover-text-colour text-report-side-bar-hover-text-colour hover:text-white hover:bg-report-side-bar-hover-text-colour"
                        onClick={(e)=>{e.preventDefault();e.stopPropagation();setName(report.title);setTagVisible(true);}}
                    >
                        +
                    </span>
                )}
              </div>

              {/* Actions */}
              <div className="flex justify-end gap-3 text-gray-400">
                <Star
                  className={`cursor-pointer
                            ${report.stared
                                ? "text-star-shade fill-star-shade hover:text-787878 hover:fill-white"
                                : "text-787878 fill-white hover:text-star-shade hover:fill-star-shade"
                            }`}
                  size={16}
                  onClick={(e) => handleStarClick(e, report.stared,report.type,report.title)}
                />
                {report.type !== "System" && (report.type !== "Custom" || canEditCustomReports) ? (
                  <>
                      <Pencil className="text-787878 cursor-pointer hover:fill-edit-color" size={16} onClick={(e) => { e.stopPropagation(); if(report.report_id) navigate(`/reports/custom-reports/editor/${report.report_id}`); }} />
                      <Trash2 className="text-787878 hover:text-F94B4B cursor-pointer" size={16} onClick={(e) => handleDeleteClick(e, report)} />
                  </>
                  ) : null}
              </div>
            </div>
          );
        })}
      </div>
      {isModalVisible && (
        <div
          className="modal-background fixed inset-0 bg-[#00000066] flex items-center justify-center z-50"
          onClick={handleOutsideClick}
        >
          <div className="bg-white p-6 rounded-lg w-80" onClick={(e) => e.stopPropagation()}>
            <h2 className="text-lg font-medium mb-4">Are you sure?</h2>
            <p className="text-sm mb-4">
              {actionType === "remove" ? "Remove this item from favorites?" : "Add this item to favorites?"}
            </p>
            <div className="flex justify-end space-x-4">
              <button
                className="px-2 py-2 bg-white border text-primary-500 rounded"
                onClick={handleCancel}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 bg-primary text-white rounded"
                onClick={handleConfirm}
              >
                {actionType === "remove" ? "Remove" : "Add"}
              </button>
            </div>
          </div>
        </div>
      )}
      {tagVisible && (
          <div
              className="tag-background fixed inset-0 bg-gradient-to-br from-black/60 via-black/50 to-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4"
              onClick={handleTagOutsideClick}
              >
              <div
                  className="bg-white p-6 rounded-lg w-80 max-w-full border border-black"
                  onClick={(e) => e.stopPropagation()}
              >
                  <h5 className="text-lg font-semibold mb-3">Add tag</h5>
  
                  <input
                  className="w-full px-3 py-2 mb-6 border border-report-side-bar-hover-text-colour rounded focus:outline-none focus:ring-1 focus:ring-primary"
                  placeholder="Enter tag name..."
                  onChange={(e) => setTagName(e.target.value)}
                  />
  
                  <h5 className="text-lg font-semibold mb-3">Select colour</h5>
  
                  <div className="grid grid-cols-3 grid-rows-2 gap-4 mb-6">
                  {Object.entries(combos).map(([key, [textClass, bgClass]]) => (
                      <div
                      key={key}
                      onClick={() => setSelectedCombo(key)}
                      className={`w-10 h-10 rounded-full cursor-pointer flex items-center justify-center
                          ${bgClassMap[bgClass]} ${textClassMap[textClass]} shadow-md transition-transform duration-200
                          ${selectedCombo === key ? 'border-4 border-report-side-bar-hover-text-colour' : ''}`}
                      title={`Shade ${key}`}
                      >
                      <BiSolidCircle size={24} />
                      </div>
                  ))}
                  </div>
  
                  <div className="flex justify-end space-x-4">
                      <button
                          className="px-3 py-2 bg-white border border-primary-500 text-primary-500 rounded hover:bg-primary-50 transition"
                          onClick={handleCancelTag}
                      >
                          Cancel
                      </button>
                      <button
                          className="px-4 py-2 rounded transition 
                                      bg-primary text-white 
                                      hover:bg-primary-dark 
                                      disabled:bg-787878 disabled:cursor-not-allowed"
                          onClick={() => handleTagConfirm()}
                          disabled={!selectedCombo || !tagName}
                          >
                          Add Tag
                      </button>
                  </div>
              </div>
          </div>

        )}
      {/* Delete Custom Report Modal */}
      {deleteModalVisible && (
        <div
          className="modal-background fixed inset-0 bg-gradient-to-br from-black/60 via-black/50 to-black/40 backdrop-blur-sm flex items-center justify-center z-50 p-4"
          onClick={handleCancelDelete}
        >
          <div
            className="bg-white p-6 rounded-lg w-80 border border-gray-200 shadow-xl"
            onClick={(e) => e.stopPropagation()}
          >
            <h2 className="text-lg font-medium mb-4">Delete Report</h2>
            <p className="text-sm mb-4 text-gray-600">
              Are you sure you want to delete "{reportToDelete?.title}"? This action cannot be undone.
            </p>
            <div className="flex justify-end space-x-4">
              <button
                className="px-4 py-2 bg-white border border-gray-300 text-gray-700 rounded hover:bg-gray-50"
                onClick={handleCancelDelete}
              >
                Cancel
              </button>
              <button
                className="px-4 py-2 text-white rounded"
                style={{ backgroundColor: '#ef4444' }}
                onClick={handleConfirmDelete}
              >
                Delete
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
) : (
  <LoadingButtonSpinner />
);

}
